import styled from "styled-components";

export const HeaderWelcomeButtonsButtonBox = styled.div`
  button {
    font-size: 0.7rem;
    padding: 1.2rem 1rem;
    margin-left: 3px;
  }
`;
